<template>
  <div class="huaao-standardSolution-check-picture" v-loading="loading">
    <div class="bigBox" v-for="component in components" v-show="component.urls.length" :key="component.id">
      <div class="box" v-for="(url,index) in component.urls" :key="url.id">
        <div class="img" v-if="url.url.toLowerCase().indexOf('mp4') === -1" :style="{'background-image':`url('${url.url}?x-oss-process=image/resize,m_fill,h_185,w_185')`}">
          <el-tag v-if='url.way'>{{url.way}}</el-tag>
        </div>
        <div class="img" v-if="url.url.toLowerCase().indexOf('mp4') > -1">
        </div>
        <p class="title" v-if="url.url.toLowerCase().indexOf('mp4') === -1">{{index+1}}.{{component.title}}</p>
        <p class="title" v-if="url.url.toLowerCase().indexOf('mp4') > -1">{{url.fileName}}</p>
        <p class="title">{{url.addTime}}</p>
        <div class="buttons">
          <el-button-group>
            <!-- <el-button type="primary" size="mini" icon="el-icon-search" @click="preview(url.url, component.title, index)"></el-button> -->
            <el-button type="primary" size="mini" icon="el-icon-search" @click="showView(url.url, (index+1) + '.' + component.title)"></el-button>
            <el-button type="primary" size="mini" icon="el-icon-download" @click="download(url.url)"></el-button>
          </el-button-group>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <el-dialog ref="pictureDialog" :class="['check-picture-dialog', fullHeight && 'full-height', fullPage && 'picture-full-screen-dialog', rotate === 90 && 'rotate-90', rotate === 180 && 'rotate-180', rotate === 270 && 'rotate-270', rotate === 0 && 'rotate-0', isFullScreen && 'picture-full-screen']"
               :visible.sync="dialogVisible"
               append-to-body
               @closed="clearImgUrl"
               :show-close="false">
      <div class="title" slot="title">查看图片 -{{indexRow}}.{{currentImgTitle}}</div>
      <div class="operation">
        <!-- 旋转 -->
        <el-button class="operation-btn" @click="updateState('rotate')"><i class="el-icon-refresh-right"></i></el-button>
        <!-- 高度100% -->
        <el-button class="operation-btn" @click="updateState('fullHeight')"><i class="fa fa-arrows-v"></i></el-button>
        <!-- 全屏 -->
        <el-button class="operation-btn" @click="fullScreen"><i class="el-icon-rank"></i></el-button>
        <!-- 页面全屏 -->
        <el-button class="operation-btn" @click="updateState('fullPage')"><i class="fa fa-expand"></i></el-button>
        <!-- 关闭 -->
        <el-button class="operation-btn" @click="dialogVisible = false, updateState(null)"><i class="el-icon-close"></i></el-button>
      </div>
      <div class="img-container">
        <i class="el-icon-arrow-left img-left" @click="previousImg"></i>
        <i class="el-icon-arrow-right img-right" @click="nextImg"></i>
        <img :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>
    <image-viewer class="pre_img"
        v-if="showViewer"
        :initial-index="showIndex"
        :on-close="onClose"
        :on-switch="onSwitch"
        :url-list="urlList.urls"/>
    <!-- 图片详情 -->
    <div class="slide-fade" v-if="showViewer" >查看图片 - {{showTitle}}</div>
    <div class="vedio-fade" v-if="showVideo">
      <el-button class="vedio-fade-closeBtn" type="primary" size="mini" icon="el-icon-close" @click="closeVideoDiv"></el-button>
      <video-player class="video-player vjs-custom-skin video-player-box"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          :x5-video-player-fullscreen="true"
          @pause="onPlayerPause($event)"
          @play="onPlayerPlay($event)"
          @fullscreenchange="onFullscreenChange($event)"
          @click="fullScreenVideo">
        </video-player>
    </div>
  </div>
</template>

<script>
import ImageViewer from 'element-ui/packages/image/src/image-viewer'
import { videoPlayer } from 'vue-video-player'
import { hls } from 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
export default {
  name: 'huaao-preview-picture',
  props: ['data'],
  components: {ImageViewer, videoPlayer, hls},
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      info: [],
      components: [],
      sharedDownloadUrl: '',
      loading: true,
      rotate: 0, // 旋转
      fullHeight: false, // 高度100
      fullPage: false, // 页面全屏
      isFullScreen: false,
      currentImgTitle: '',
      indexRow: 0, // 查看图片的下标
      showIndex: 0,
      urlList: { // 图片url集合
        urls: [],
        urlTitle: []
      },
      showTitle: '',
      showViewer: false, // 查看框显示隐藏
      showVideo: false, // 视频查看界面隐藏
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: ''
        }],
        width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 全屏按钮
          volumePanel: { // 让音量键竖直
            inline: false
          }
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    isMaintenance () {
      // 是否是维修管理或者我的维修报表
      return this.$route.path.indexOf('16A47D5D-8510-E6B7-5644-DE9867EF4D58') !== -1 || this.$route.path.indexOf('16A102C5-A490-314A-BA8A-C32064D4BDBF') !== -1
    },
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    async init () {
      this.sharedDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
      // 查询控件
      let path
      if (this.data.from === '维修' || this.isMaintenance) {
        path = `repair/picInfoList/${this.data.dataId}`
      } else {
        path = 'checkcar/getUploadPicInfoList'
      }
      await this.$axios.get(`/huaao-api/${path}`).then((res) => {
        res.data.forEach(n => this.components.push({
          id: n.id,
          title: n['upload_item_name'],
          isSingle: n['is_it_a_leaflet_1'] === '1',
          max: n['maximum_uploads_number'],
          urls: []
        }))
      })

      // 查询数据
      let type
      if (this.data.from === '维修' || this.isMaintenance) {
        type = 6
      } else {
        type = 4
      }
      await this.$axios.get('/huaao-api/checkcar/getCheckCarPic', {params: {dataId: this.data.dataId, type: type}}).then((res) => {
        this.info = res.data
        res.data.forEach(n => {
          let component = this.components.find(j => j.id === n['project_id_1'])
          component && component.urls.push({
            id: n.id,
            url: this.sharedDownloadUrl + n['picture_path_1'],
            way: n['document_approach'],
            fileName: n['file_name_1'] && n['file_name_1'].split('#')[n['file_name_1'].split('#').length - 1],
            addTime: n.CreatedTime && n.CreatedTime.split(' ')[0]
          })
          let index = component && component.urls.length
          if (n['picture_path_1'].toLowerCase().indexOf('mp4') === -1) {
            component && this.urlList.urls.push(this.sharedDownloadUrl + n['picture_path_1']) && this.urlList.urlTitle.push(index + '.' + component.title)
          }
        })
      })
      this.loading = false
    },
    preview (url, title, index) {
      this.dialogImageUrl = url
      this.currentImgTitle = title
      this.dialogVisible = true
      this.indexRow = index + 1
    },
    download (url) {
      window.open(url)
    },
    previousImg () {
      let currentImgIndex
      currentImgIndex = this.info.findIndex(item => {
        return this.dialogImageUrl.indexOf(item['picture_path_1']) !== -1
      })
      if (currentImgIndex === 0) {
        return this.$message.info('已经是第一张')
      }
      let previousImgUrl = this.info[currentImgIndex - 1]['picture_path_1']
      let urls = this.components.find(item => {
        return item.urls.length && item.urls.some(e => e.url.indexOf(previousImgUrl) !== -1)
      })
      this.currentImgTitle = urls.title
      this.dialogImageUrl = this.sharedDownloadUrl + previousImgUrl
      this.indexRow = urls.urls.findIndex(item => {
        return this.currentImgTitle && item.url === this.dialogImageUrl
      }) + 1
    },
    nextImg () {
      let currentImgIndex
      currentImgIndex = this.info.findIndex(item => {
        return this.dialogImageUrl.indexOf(item['picture_path_1']) !== -1
      })
      if (currentImgIndex === this.info.length - 1) {
        return this.$message.info('已经是最后一张')
      }
      let nextImgUrl = this.info[currentImgIndex + 1]['picture_path_1']
      let urls = this.components.find(item => {
        return item.urls.length && item.urls.some(e => e.url.indexOf(nextImgUrl) !== -1)
      })
      this.currentImgTitle = urls.title
      this.dialogImageUrl = this.sharedDownloadUrl + nextImgUrl
      this.indexRow = urls.urls.findIndex(item => {
        return this.currentImgTitle && item.url === this.dialogImageUrl
      }) + 1
    },
    clearImgUrl () {
      this.dialogImageUrl = ''
    },
    fullScreen () {
      let fullscreenEnabled = document.fullscreenEnabled ||
          document.mozFullScreenEnabled ||
          document.webkitFullscreenEnabled ||
          document.msFullscreenEnabled
      if (!fullscreenEnabled) { return this.$message.error('当前浏览器不能全屏') }
      if (this.isFullScreen) {
        this.cancelFullscreen()
      } else {
        this.requestFullScreen(this.$refs.pictureDialog.$el)
      }
      this.isFullScreen = !this.isFullScreen
    },
    // 0：正常
    // 1：旋转
    // 2：高度100
    // 3：半全屏
    updateState (attr) {
      if (this.isFullScreen) {
        if (attr === 'fullHeight') return
        else if (attr === 'fullPage') return this.fullScreen()
      }
      if (attr === null) {
        this.rotate = 0
        this.fullHeight = false
        this.fullPage = false
      } else {
        if (attr !== 'rotate') {
          this[attr] = !this[attr]
        } else {
          this[attr] = this[attr] === 0 ? 90 : this[attr] === 90 ? 180 : this[attr] === 180 ? 270 : this[attr] === 270 ? 0 : 270
        }
      }
    },
    requestFullScreen (de) {
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    cancelFullscreen () {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    },
    showView (url, urlTitle) {
      if (url.toLowerCase().indexOf('mp4') > -1) {
        this.playerOptions.sources[0].src = url
        this.showVideo = true
      } else {
        this.showTitle = urlTitle
        this.showIndex = this.getArrayIndex(this.urlList.urls, url)
        this.showViewer = true
      }
    },
    onClose () {
      this.showViewer = false
    },
    // 切换图片 index为图片下标值
    onSwitch (index) {
      // console.log(index)
      this.showIndex = index
      this.showTitle = this.urlList.urlTitle[index]
    },
    getArrayIndex (arr, obj) {
      let i = arr.length
      while (i--) {
        if (arr[i] === obj) {
          return i
        }
      }
      return -1
    },
    fullScreenVideo () {
      const player = this.$refs.videoPlayer.player
      player.requestFullscreen() // 调用全屏api方法
      player.isFullscreen(true)
      player.play()
    },
    onPlayerPlay (player) {
      player.play()
    },
    onPlayerPause (player) {
      // alert("pause");
    },
    onFullscreenChange (player) {

    },
    closeVideoDiv () {
      this.playerOptions.sources.src = ''
      this.showVideo = false
    }
  },
  watch: {
    dialogVisible (val) {
      if (!val) {
        this.updateState(null)
      }
    }
  }
}
</script>

<style lang="scss">
  .check-picture-dialog {
    width: 100%;
    height: 100%;
    .el-dialog__header {
      .title {
        font-size: 24px;
      }
    }
    .el-dialog {
      width: 900px;
      height: 510px;
      .el-dialog__body {
        box-sizing: border-box;
        position: relative;
        padding: 20px;
        height: calc(100% - 44px) !important;
        width: 100%;
        .operation {
          position: absolute;
          right: 20px;
          top: -38.5px;

          .operation-btn {
            width: 40px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            padding: 0;
            font-size: 16px;
            span {
              i {
                color: #333;
              }
            }
          }
        }
        .img-container {
          width: 100%;
          height: 100%;
          overflow: hidden !important; // 样式层级相同被覆盖了
          img {
            height: 100%;
            width: 100%;
          }
          .img-left{
            position: absolute;
            font-size: 90px;
            left: 10px;
            top: 50%;
            margin-top: -45px;
            z-index: 9999;
            cursor: pointer;
            opacity: 0.6;
          }
          .img-right{
            position: absolute;
            font-size: 90px;
            right: 10px;
            top: 50%;
            margin-top: -45px;
            z-index: 9999;
            cursor: pointer;
            color: #B0C4DE;
            opacity: 0.6;
          }
        }
      }
    }
  }
  .huaao-standardSolution-check-picture {
    height: 100%;
    background-color: #fff;
    overflow: auto;
    .clear {
      clear: both;
    }
    .bigBox {
      background: #fff;
      padding: 10px;
      margin-bottom: 20px;
      border-radius: 4px;
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
      transform: translate3d(0, -2px, 0);
    }
    .box {
      float: left;
      padding: 6px;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-right: 10px;
      .img {
        width: 185px;
        height: 185px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 4px;
      }
      .title {
        text-align: center;
        height: 30px;
        line-height: 30px;
      }
      .buttons {
        .el-button-group {
          float: right;
        }
      }
    }
    .goback {
      position: fixed;
      right: 20px;
      bottom: 20px;
    }
  }
  .picture-full-screen-dialog {
    width: 100%;
    height: 100%;
    overflow: hidden !important; // 样式层级相同被覆盖了
    .el-dialog {
      width: 100%;
      height: 100%;
      margin-top: 0!important;
    }

    .el-dialog__body {
      height: 100%;
    }
  }
  .rotate-90 {
    .el-dialog {
      .el-dialog__body {
        img {
          transform: rotate(90deg);
        }
      }
    }
  }
  .rotate-180 {
    .el-dialog {
      .el-dialog__body {
        img {
          transform: rotate(180deg);
        }
      }
    }
  }
  .rotate-270 {
    .el-dialog {
      .el-dialog__body {
        img {
          transform: rotate(270deg);
        }
      }
    }
  }
  .rotate-0 {
    .el-dialog {
      .el-dialog__body {
        img {
          transform: rotate(0deg);
        }
      }
    }
  }
  .full-height {
    width: 100%;
    height: 100%;
    overflow: hidden !important; // 样式层级相同被覆盖了
    .el-dialog {
      height: 100%;
      margin-top: 0 !important;
      .el-dialog__body {
        height: 100%;
      }
    }
  }
  .picture-full-screen {
    .el-dialog {
      width: 100%;
      height: 100%;
      margin: 0 !important;
    }
  }
  .slide-fade {
    position:fixed;
    // margin:auto;
    color:#fff;
    left:50%;
    right:0;
    top:10px;
    width:auto;
    display:inline-block !important;
    display:inline;
    height: 44px;
    line-height: 44px;
    font-size: 22px;
    text-align: center;
    transform: translateX(-50%);
    padding: 0 23px;
    background-color: #606266;
    border-color: #fff;
    border-radius: 22px;
  }
  .vedio-fade {
    position: fixed;
    top:0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
  .vedio-fade-closeBtn {
    position: absolute;
    right: 20px;
    top: 20px;
    color: blue;
    z-index: 9999;
  }
  .video-js .vjs-big-play-button {
    width: 72px;
    height: 72px;
    border-radius: 100%;
    z-index: 100;
    background-color: #ffffff;
    border: solid 1px #979797;
  }
  .video-js .vjs-control-bar {
    position: fixed !important;
  }
</style>



// WEBPACK FOOTER //
// src/globalComponent/publicPreview/components/huaao-preview-picture.vue